<div class="panel" [ngClass]="{ pin: pinned, open: isOpened }">
  <div>
    <dx-button
      icon="close"
      stylingMode="text"
      (onClick)="onClosePanel()"
    ></dx-button>

    <div *ngIf="selectedVisaApplication">
      <div class="data-wrapper">
        <div class="row dx-fieldset dx-panel-item">
          <span class="mb-3 text-black">İletişim Kurulacak Kişi</span>
          <div class="col-6">
            <div class="dx-field">
              <div class="dx-field-label">Ad</div>
              <div class="dx-field-value">
                <dx-text-box
                  [inputAttr]="{ 'aria-label': 'Name' }"
                  [(value)]="selectedVisaApplication.customerFirstName"
                  class="input"
                  style="padding: 2px; font-size: 12px"
                  [readOnly]="true"
                >
                </dx-text-box>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Telefon</div>
              <div class="dx-field-value">
                <dx-text-box
                  mask="(X00) 000-0000"
                  [maskRules]="rules"
                  [inputAttr]="{ 'aria-label': 'Mask' }"
                  [(value)]="selectedVisaApplication.customerPhoneNumber"
                  [readOnly]="true"
                >
                </dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">SMS:</div>
              <div class="dx-field-value">
                <dx-check-box
                  [(value)]="selectedVisaApplication.smsRequest"
                  [elementAttr]="{ 'aria-label': 'Checked' }"
                  [readOnly]="true"
                ></dx-check-box>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="dx-field">
              <div class="dx-field-label">Soyad</div>
              <div class="dx-field-value">
                <dx-text-box
                  [inputAttr]="{ 'aria-label': 'Name' }"
                  [(value)]="selectedVisaApplication.customerLastName"
                  [readOnly]="true"
                >
                </dx-text-box>
              </div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">E-Posta</div>
              <div class="dx-field-value">
                <dx-text-box
                  [inputAttr]="{ 'aria-label': 'Name' }"
                  [(value)]="selectedVisaApplication.email"
                  [readOnly]="true"
                >
                </dx-text-box>
              </div>
            </div>
          </div>
        </div>

        <div class="row dx-panel-item">
          <span class="mb-3 text-black">Kişi Bilgileri</span>
          <div class="personal-info-panel">
            <div class="info-row">
              <div class="info-item">
                <p><span>Pasaport No:</span></p>
                <p>
                  {{ selectedVisaApplication.customerPassportNumber ?? "    " }}
                </p>
              </div>
              <div class="info-item">
                <p><span>Doğum Tarihi:</span></p>
                <p>
                  {{ selectedVisaApplication.birthDate | date : "dd.MM.yyyy" }}
                </p>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <p><span>Doğum Ülkesi:</span></p>
                <p>{{ selectedVisaApplication.birthCountry.cultureCode }}</p>
              </div>
              <div class="info-item">
                <p><span>Doğum Yeri:</span></p>
                <p>{{ selectedVisaApplication.birthPlace }}</p>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <p><span>Medeni Durum:</span></p>
                <p>{{ selectedVisaApplication.maritalStatus }}</p>
              </div>
              <div class="info-item">
                <p><span>Aile Üyeliği:</span></p>
                <p>{{ selectedVisaApplication.familyMembership }}</p>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <p><span>Pasaport Bitiş :</span></p>
                <p>
                  {{
                    selectedVisaApplication.passportExpiryDate
                      | date : "dd.MM.yyyy"
                  }}
                </p>
              </div>
              <div class="info-item">
                <p><span>Pasaport Veriliş:</span></p>
                <p>
                  {{
                    selectedVisaApplication.passportIssueDate
                      | date : "dd.MM.yyyy"
                  }}
                </p>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <p><span>Geldiği Ülke:</span></p>
                <p>{{ selectedVisaApplication.comingCountry.cultureCode }}</p>
              </div>
              <div class="info-item">
                <p><span>Uyruk:</span></p>
                <p>{{ selectedVisaApplication.nationality.passportCode }}</p>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <p><span>Eğitim Durumu:</span></p>
                <p>{{ selectedVisaApplication.educationStatus }}</p>
              </div>
              <div class="info-item">
                <p><span>Meslek:</span></p>
                <p>{{ selectedVisaApplication.profession }}</p>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <p><span>TC No:</span></p>
                <p>
                  {{ selectedVisaApplication.customerNationalityNumber ?? " " }}
                </p>
              </div>
              <div class="info-item">
                <p><span>Din:</span></p>
                <p>{{ selectedVisaApplication.religion }}</p>
              </div>
            </div>
            <div class="info-row">
              <div class="info-item">
                <p><span>Cinsiyet:</span></p>
                <p>{{ selectedVisaApplication.gender }}</p>
              </div>
              <div class="info-item">
                <p><span>Dil:</span></p>
                <p>{{ selectedVisaApplication.language }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="row dx-panel-item">
          <span class="mb-3 text-black">Vize Bilgileri</span>
          <div class="col-3">
            <p><span>Vize Tarihi:</span></p>
            <p><span>Vize Türü:</span></p>
            <p><span>Başvuru Türü:</span></p>
          </div>
          <div class="col-3">
            <p
              (click)="
                copyTextFromDate(selectedVisaApplication.visaDate, 'visaDate')
              "
              [ngClass]="{ copied: copiedField === 'visaDate' }"
              class="copyable"
            >
              {{ selectedVisaApplication.visaDate | date : "dd.MM.yyyy" }}
              <span *ngIf="copiedField === 'visaDate'" class="copy-status"
                >Kopyalandı!</span
              >
            </p>

            <p>{{ selectedVisaApplication.visaType }}</p>
            <p>{{ selectedVisaApplication.applicationType }}</p>
          </div>
          <div class="col-3">
            <p><span>Vize Ülkesi:</span></p>
            <p><span>Vize Süresi:</span></p>
            <p><span>Vize Aciliyeti:</span></p>
          </div>
          <div class="col-3">
            <p>{{ selectedVisaApplication.visaCountry }}</p>
            <p>{{ selectedVisaApplication.visaTime }}</p>
            <p>{{ selectedVisaApplication.visaLevelName }}</p>
          </div>
        </div>

        <div class="row dx-panel-item">
          <span class="mb-3 text-black">Fatura Bilgileri</span>
          <div class="col-12">
            <dx-button
              type="default"
              stylingMode="outlined"
              text="FATURA KES"
              class="margin mt-2 mb-2"
              style="display: flex; align-items: end"
              (onClick)="sendInvoice()"
              [disabled]="
                selectedVisaApplication.isInvoiceSended === true ||
                selectedVisaApplication.visaPaymentStatus != 2
              "
              style="display: flex; align-items: end"
            ></dx-button>
          </div>
          <div class="col-12">
            <dx-button
              type="default"
              stylingMode="outlined"
              text="FATURA GÖRÜNTÜLE"
              class="margin mt-2 mb-2"
              style="display: flex; align-items: end"
              [disabled]="selectedVisaApplication.isInvoiceSended === false"
              (onClick)="showInvoicePdf()"
              style="display: flex; align-items: end"
            ></dx-button>
          </div>
          <div class="col-12">
            <dx-button
              type="default"
              stylingMode="outlined"
              text="FATURA MAILI GÖNDER"
              class="margin mt-2 mb-2"
              (onClick)="sendInvoiceMail()"
              [disabled]="selectedVisaApplication.isInvoiceSended === false"
              style="display: flex; align-items: end"
            ></dx-button>
          </div>
          <div class="col-4">
            <p style="margin: 2px 0px 35px"><span>Fatura No:</span></p>
            <p><span>Fatura Tarihi:</span></p>
          </div>
          <div class="col-8">
            <p>{{ selectedVisaApplication.invoiceNumber }}</p>
            <p>{{ selectedVisaApplication.invoiceDate }}</p>
          </div>
        </div>
        <div class="row dx-panel-item">
          <span class="mb-3 text-black">Teslimat Adresi ve Kargo </span>
          <div class="info-row">
            <p>{{ selectedVisaApplication.deliveryAddress }}</p>
            <div class="deliveryInfos">
              <dx-check-box style="margin-right: 9px"  [(value)]="selectedVisaApplication.isCargoSended"    text="Vize, müşteriye kargolandı" ></dx-check-box>
             
            </div>
          </div>
        </div>
        <div class="row dx-panel-item">
          <span class="mb-3 text-black">Satış Fiyatları ve Komisyon Oranı</span>
          <div class="col-6">
            <p><span>Vize Toplam Fiyatı:</span></p>
            <p><span>Uygulanan İndirim Oranı:</span></p>
          </div>
          <div class="col-6">
            <p>
              {{ selectedVisaApplication.totalAmount | numberFormatter }} $ 
              ({{ selectedVisaApplication.totalTrAmount | number:'1.2-2' }} TL)
            </p>
            <p>
              {{ selectedVisaApplication.discountRate * 100  }} %
            </p>
         
          </div>

          <span class="text-black mb-3 mt-3 text-bold"> Belge Görüntüle</span>
          <dx-button
            type="default"
            stylingMode="outlined"
            text="PASAPORT RESMİ"
            class="margin mt-2 mb-2"
            style="display: flex; align-items: end"
            (onClick)="
              openImage('Pasaport Resmi', selectedVisaApplication.passportPhoto)
            "
          ></dx-button>
          <dx-button
            type="default"
            stylingMode="outlined"
            text="BİYOMETRİK RESİM"
            class="margin"
            style="display: flex; align-items: end"
            (onClick)="
              openImage(
                'Biyometrik Resim',
                selectedVisaApplication.biometricPhoto
              )
            "
          ></dx-button>
          <span class="text-black mb-3 mt-3 text-bold"> Belge İndir</span>
          <dx-button
            type="default"
            stylingMode="outlined"
            text="PASAPORT RESMİ İNDİR"
            class="margin mt-2 mb-2"
            style="display: flex; align-items: end"
            (onClick)="
              downloadFile(
                selectedVisaApplication.passportPhoto,
                'passportFoto'
              )
            "
          ></dx-button>
          <dx-button
            type="default"
            stylingMode="outlined"
            text="BİYOMETRİK RESMİ İNDİR"
            class="margin mt-2 mb-2"
            style="display: flex; align-items: end"
            (onClick)="
              downloadFile(selectedVisaApplication.biometricPhoto, 'bioFoto')
            "
          ></dx-button>
          <dx-button
            type="default"
            stylingMode="outlined"
            text="OTEL BİLGİSİ İNDİR"
            class="margin mt-2 mb-2"
            style="display: flex; align-items: end"
            (onClick)="
              downloadFile(
                selectedVisaApplication.hotelReservationUrl,
                'otelBilgisi'
              )
            "
          ></dx-button>
          <dx-button
            type="default"
            stylingMode="outlined"
            text="UÇAK BİLETİ İNDİR"
            class="margin mt-2 mb-2"
            style="display: flex; align-items: end"
            (onClick)="
              downloadFile(
                selectedVisaApplication.returnTicketUrl,
                'ucakBileti'
              )
            "
          ></dx-button>
          <span class="text-black mb-3 mt-3 text-bold"> Vize Dökümanı</span>

          <dx-file-uploader
            [multiple]="false"
            accept=".html"
            uploadMode="useForm"
            [selectButtonText]="'VİZE DÖKÜMANI YÜKLE'"
            [labelText]="''"
            (onValueChanged)="onVisaDocUploaded($event)"
            *ngIf="!selectedVisaApplication.visaDocumentUrl"
          >
          </dx-file-uploader>

          <div
            *ngIf="visaUploadError"
            class="text-danger mt-2 text-bold"
            style="font-size: 13px; font-weight: bold"
          >
            {{ visaUploadError }}
          </div>

          <div
            *ngIf="visaDeleteMessage"
            [ngClass]="{
              'text-success': visaDeleteMessageStatus === 'success',
              'text-danger': visaDeleteMessageStatus === 'error'
            }"
            class="mt-2 text-bold"
            style="font-size: 13px"
          >
            {{ visaDeleteMessage }}
          </div>

          <!-- Eğer vize dokümanı varsa göster -->
          <div *ngIf="selectedVisaApplication.visaDocumentUrl" class="mt-2">
            <div class="row">
              <div class="col-6">
                <dx-button
                  text="GÖRÜNTÜLE"
                  icon="eye"
                  type="default"
                  class="w-100 mt-2"
                  (onClick)="openVisaDocInNewTab()"
                >
                  <!--
              (onClick)="onShowPopup()" -->
                </dx-button>
              </div>

              <div class="col-6">
                <dx-button
                  text="SİL"
                  type="danger"
                  icon="trash"
                  class="w-100 mt-2"
                  (onClick)="deleteVisaDocument()"
                >
                </dx-button>
              </div>
            </div>
          </div>

          <br /><br /><br />

          <dx-button
            *ngIf="selectedVisaApplication.visaDocumentUrl"
            text="E-Posta Bildirimi Gönder"
            icon="email"
            type="default"
            class="w-100 mt-2"
            (onClick)="sendVisaEmailNotification()"
          >
          </dx-button>
          <dx-button
            *ngIf="
              selectedVisaApplication.visaDocumentUrl &&
              selectedVisaApplication.smsRequest
            "
            text="SMS Bildirimi Gönder"
            icon="sms"
            type="default"
            class="w-100 mt-2"
            (onClick)="sendVisaSmsNotification(selectedVisaApplication)"
          >
          </dx-button>
          <div
            *ngIf="mailWarningMessage"
            [ngClass]="{
              'text-success': mailStatus === 'success',
              'text-danger': mailStatus === 'error'
            }"
            class="mt-2 text-bold"
            style="font-size: 13px"
          >
            {{ mailWarningMessage }}
          </div>

          <dx-popup
            [(visible)]="documentPopupVisible"
            [showTitle]="true"
            [title]="'Vize Dökümanı Önizleme'"
            [width]="900"
            [height]="600"
            [closeOnOutsideClick]="true"
            [dragEnabled]="true"
            [showCloseButton]="true"
          >
            <div *dxTemplate="let data of 'content'">
              <ng-container *ngIf="selectedVisaApplication?.visaDocumentUrl">
                <div
                  class="visa-html-wrapper"
                  [innerHTML]="visaHtmlContent"
                  *ngIf="visaHtmlContent"
                ></div>
              </ng-container>
            </div>
          </dx-popup>

          <br /><br /><br /><br />
          <div class="row bottom">
            <div class="col-8">
              <label>Not</label>

              <dx-text-area
                height="70px"
                maxLength="maxLength"
                [(value)]="selectedVisaApplication.note"
                (autoResizeEnabled)="(true)"
                [inputAttr]="{ 'aria-label': 'Notes' }"
              >
              </dx-text-area>


            </div>
          </div>
        </div>
      </div>

      <dx-popup
        [(visible)]="popupVisible"
        [showTitle]="true"
        [title]="imageTitle"
        [showCloseButton]="true"
        [width]="600"
        height="auto"
        [dragEnabled]="true"
        [closeOnOutsideClick]="true"
      >
        <div class="text-center p-2">
          <img
            [src]="imageUrl"
            alt="Görsel"
            style="max-width: 100%; max-height: 500px"
          />
        </div>
      </dx-popup>
    </div>
    <div
      style="
        position: sticky;
        bottom: -1rem;
        width: 100%;
        height: 4rem;
        background: white;
      "
    >
      <div
        class="col-4 btn"
        style="width: -webkit-fill-available; height: -webkit-fill-available"
      >
        <dx-button
          style="height: -webkit-fill-available"
          icon="update"
          type="default"
          stylingMode="outlined"
          text="Güncelle"
          class="margin"
          style="display: flex; align-items: end"
          (onClick)="update()"
        ></dx-button>
      </div>
    </div>
  </div>
</div>
